import React from "react";
import { Link, NavLink } from "react-router-dom";
import Logo from "../Components/Logo/Logo";

const Navbar = () => {
  // const data = [
  //   { id: 1, title: "Gi Corrugated Sheets" },
  //   { id: 2, title: "Colour Coated Sheets & Accessories" },
  //   { id: 3, title: "C & Z Purlins" },
  //   { id: 4, title: "Deck Sheets" },
  //   { id: 5, title: "Gi Plain Sheets" },
  // ];

  const wireData = [
    { id: 1, title: "MS Gi Binding Wire" },
    { id: 2, title: "PVC Coated Gi Binding Wire" },
    { id: 3, title: "Weld Mesh" },
    { id: 4, title: "PVC Gi Chain Link Mesh" },
    { id: 5, title: "Gi Barbed Wire" },
    { id: 6, title: "MS Wire Nails" },
  ];

  //   WIRE PRODUCTS :-
  // •	GI BINDING WIRE
  // •	MS BINDING WIRE
  // •	PVC COATED BINDING WIRE
  // •	PVC COATED LINK MESH
  // •	BARBED WIRE
  // •	MS WELD MESH
  // •	GI WELD MESH
  // •	GI CHAIN LINK MESH
  // •	MS WIRE NAILS

  // GALVANIZED AND COATED PRODUCTS :-
  // •	GI PLAIN SHEETS
  // •	GI CORRUGATED SHEETS
  // •	PRE- PAINTED GALVANIZED PROFILE SHEETS
  // •	BOILER QUALITY PLATES
  // •	SAIL HARD PLATES
  // •	C & Z PURLINS
  // •	DECK SHEETS
  // •	CUT PLATES/SPECIAL SIZE PLATES
  // PIPES :-
  // •	SQUARE HOLLOW SECTIONS
  // •	RECTANGULAR HOLLOW SECTIONS
  // •	CIRCULAR HOLLOW SECTIONS
  // •	GI PIPES
  // •	SEAMLESS PIPES

  // STRUCTURAL STEEL :-
  // LONG PRODUCTS
  // •	MS ANGLE (ISA)
  // •	MS BEAM (ISMB)
  // •	MS CHANNEL (ISMC)
  // •	MS FLATS (ISF)
  // •	TMT BARS
  // •	ROUND BARS
  // •	SQUARE BARS
  // •	CRANE RAILS,IU RAILS, RAILS (USED AND NEW)

  // FLAT PRODUCTS
  // •	MS PLATES
  // •	CR SHEETS
  // •	CHEQUERED PLATES
  // •	BOILER QUALITY PLATES
  // •	SAIL HARD PLATES
  // •	CUT PLATES / SPECIAL SIZE PLATES 

  // SCAFFOLDING ACCESSORIES :-
  // •	SWIVEL COUPLERS
  // •	TIE RODS
  // •	ALL TYPES OF CLAMPS (UNIVERSAL,SHUTTERING,LADDER)
  // •	WALLER PLATE
  // •	ADJUSTABLE PROPS
  // •	BASE JACK & U JACK
  // •	WEDGE CLIP Etc.
  // OTHER PRODUCTS :-
  // •	STAINLESS STEEL PRODUCTS
  // •	ALUMINIUM PRODUCTS
  // •	COPPER PRODUCTS
  // •	METAL BEAM CRASH BARRIER

  const data = [
    {
      title: "Wire Products", // completed
      count: 9,
      products: [
        { id: "WPA7", name: "GI Binding Wire" },
        { id: "WPF3", name: "MS Binding Wire" },
        { id: "WPX1", name: "PVC Coated Binding Wire" },
        { id: "WPQ9", name: "PVC Coated Link Mesh" },
        { id: "WPD4", name: "Barbed Wire" },
        { id: "WPM6", name: "MS Weld Mesh" },
        { id: "WPG8", name: "GI Weld Mesh" },
        { id: "WPR2", name: "GI Chain Link Mesh" },
        { id: "WPB5", name: "MS Wire Nails" },
      ],
    },
    {
      title: "Galvanized and Coated Products",
      count: 7, // completed
      products: [
        { id: "GCX9", name: "GI Plain Sheets" },
        { id: "GCK3", name: "GI Corrugated Sheets" },
        { id: "GCE1", name: "Pre-Painted Galvanized Profile Sheets" }, // Sub Product
        { id: "GCW2", name: "Sail Hard Plates" },
        { id: "GCY7", name: "C Purlins" }, // Sub Product
        { id: "GCZ4", name: "Z Purlins" },
        { id: "GCH5", name: "Deck Sheets" },
      ],
    },
    {
      title: "Pipes", // completed
      count: 5,
      products: [
        { id: "PPQ1", name: "Square Hollow Sections" },
        { id: "PPL4", name: "Rectangular Hollow Sections" },
        { id: "PPC2", name: "MS Round Pipes" },
        { id: "PPX8", name: "GI Pipes" },
        { id: "PPS6", name: "Seamless Pipes" },
      ],
    },
    {
      title: "Structural Steel - Long Products",
      count: 8,
      products: [
        { id: "SSL7", name: "MS Angle (ISA)" },
        { id: "SSB1", name: "MS Beam (ISMB)" },
        { id: "SSC9", name: "MS Channel (ISMC)" },
        { id: "SSF4", name: "MS Flats (ISF)" },
        { id: "SST3", name: "TMT Bars" },
        { id: "SSR2", name: "Round Bars" },
        { id: "SSQ5", name: "Square Bars" },
        { id: "SSU6", name: "Crane Rails, IU Rails, Rails (Used and New)" }, // Sub produtcs
      ],
    },
    {
      title: "Structural Steel - Flat Products",
      count: 6,
      products: [
        { id: "SFP5", name: "MS Plates" }, // pending
        { id: "SFC1", name: "CR Sheets" }, // pending
        { id: "SFE9", name: "Chequered Plates" }, // pending
        { id: "SFB3", name: "Boiler Quality Plates" }, // pending
        { id: "SFS6", name: "Sail Hard Plates" }, // pending
        { id: "SFT2", name: "Cut Plates / Special Size Plates" },
      ],
    },
    {
      title: "Scaffolding Accessories", // pending
      count: 7,
      products: [
        { id: "SAA1", name: "Swivel Couplers" },
        { id: "SAT8", name: "Tie Rods" },
        {
          id: "SAC4",
          name: "Shuttering clamp",
        },
        { id: "SAW3", name: "Waller Plate" },
        { id: "SAP6", name: "Adjustable Props" },
        { id: "SAB2", name: "Base Jack & U Jack" },
        { id: "SAW7", name: "Wedge Clip Etc." },
      ],
    },
    {
      title: "Other Products", // pending
      count: 4,
      products: [
        { id: "OPS9", name: "Stainless Steel Products" },
        { id: "OPA3", name: "Aluminium Products" },
        { id: "OPC5", name: "Copper Products" },
        { id: "OPM1", name: "Metal Beam Crash Barrier" },
      ],
    },
  ];

  return (
    <>
      <div className="container position-sticky z-index-sticky top-0">
        <div className="row">
          <div className="col-12">
            <nav className="bg-white navbar navbar-expand-lg blur blur-rounded top-0 z-index-fixed shadow position-fixed my-3 py-2 start-0 end-0 mx-4">
              <div className="container overflow h-50">
                <Link
                  to="/"
                  className="navbar-brand d-flex align-items-center me-lg-3"
                  title="Designed and Coded by Creative Tim"
                >
                  <Logo />
                </Link>
                <button
                  className="navbar-toggler shadow-none ms-2"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#navigation"
                  aria-controls="navigation"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <span className="navbar-toggler-icon mt-2">
                    <span className="navbar-toggler-bar bar1" />
                    <span className="navbar-toggler-bar bar2" />
                    <span className="navbar-toggler-bar bar3" />
                  </span>
                </button>
                <div
                  className="collapse navbar-collapse w-100 pt-3 pb-2 py-lg-0"
                  id="navigation"
                >
                  <ul className="navbar-nav navbar-nav-hover mx-auto">
                    <li className="nav-item mx-2">
                      <NavLink
                        to="/"
                        className={({ isActive }) =>
                          `nav-link ps-2 d-flex justify-content-between cursor-pointer align-items-center ${
                            isActive ? "text-primary font-weight-bold" : ""
                          }`
                        }
                      >
                        Home
                      </NavLink>
                    </li>
                    <li className="nav-item mx-2">
                      <NavLink
                        to="/about"
                        className={({ isActive }) =>
                          `nav-link ps-2 d-flex justify-content-between cursor-pointer align-items-center ${
                            isActive ? "text-primary font-weight-bold" : ""
                          }`
                        }
                      >
                        About Us
                      </NavLink>
                    </li>

                    {/* Products Dropdown */}
                    <li className="nav-item dropdown dropdown-hover mx-2">
                      <a
                        role="button"
                        className="nav-link ps-2 d-flex justify-content-between cursor-pointer align-items-center"
                        id="dropdownMenuProducts"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        onClick={() => {
                          // visible mobile dropdown
                          var dropdown =
                            document.querySelector(".mob-nav-action");
                          if (dropdown.classList.contains("d-none")) {
                            dropdown.classList.remove("d-none");
                            dropdown.classList.add("d-block");
                          } else {
                            dropdown.classList.remove("d-block");
                            dropdown.classList.add("d-none");
                          }
                        }}
                      >
                        Products
                        <img
                          src="../img/down-arrow-dark.svg"
                          alt="down-arrow"
                          className="arrow ms-1"
                        />
                      </a>
                      <div
                        className="dropdown-menu dropdown-menu-animation dropdown-lg mt-0 mt-lg-3 border-radius-lg d-none d-lg-block"
                        aria-labelledby="dropdownMenuProducts"
                        style={{ display: "block", gap: "1rem" }}
                      >
                        <div className="white-bg p-3">
                          <div className="d-flex justify-content-between">
                            {/* Product 1 */}
                            <div className="w-auto">
                              <span className="dropdown-header nav-text-dark">
                                {data[0].title}
                              </span>
                              <div className="dropdown-underlined"></div>
                              <ul className="list-group">
                                {data[0].products.map((item) => (
                                  <li
                                    key={item.id}
                                    className="nav-item list-group-item border-0 p-0 "
                                  >
                                    <a
                                      href={"/ProductDetail/" + item.id}
                                      className="dropdown-item pb-2 ps-3 border-radius-md text-red"
                                    >
                                      {item.name}
                                    </a>
                                  </li>
                                ))}
                              </ul>
                            </div>

                            {/* Product 2 */}
                            <div className="w-auto">
                              <span className="dropdown-header nav-text-dark">
                                {data[1].title}
                              </span>
                              <div className="dropdown-underlined"></div>
                              <ul className="list-group">
                                {data[1].products.map((item) => (
                                  <li
                                    key={item.id}
                                    className="nav-item list-group-item border-0 p-0 "
                                  >
                                    <a
                                      href={"/ProductDetail/" + item.id}
                                      className="dropdown-item pb-2 ps-3 border-radius-md text-red"
                                    >
                                      {item.name}
                                    </a>
                                  </li>
                                ))}
                              </ul>
                            </div>

                            {/* Product 3 */}
                            <div className="w-auto">
                              <span className="dropdown-header nav-text-dark">
                                {data[2].title}
                              </span>
                              <div className="dropdown-underlined"></div>
                              <ul className="list-group">
                                {data[2].products.map((item) => (
                                  <li
                                    key={item.id}
                                    className="nav-item list-group-item border-0 p-0 "
                                  >
                                    <a
                                      href={"/ProductDetail/" + item.id}
                                      className="dropdown-item pb-2 ps-3 border-radius-md text-red"
                                    >
                                      {item.name}
                                    </a>
                                  </li>
                                ))}
                              </ul>
                            </div>

                            {/* Product 4 */}
                            <div className="w-auto">
                              <span className="dropdown-header nav-text-dark">
                                {data[3].title}
                              </span>
                              <div className="dropdown-underlined"></div>
                              <ul className="list-group">
                                {data[3].products.map((item) => (
                                  <li
                                    key={item.id}
                                    className="nav-item list-group-item border-0 p-0 "
                                  >
                                    <a
                                      href={"/ProductDetail/" + item.id}
                                      className="dropdown-item pb-2 ps-3 border-radius-md text-red"
                                    >
                                      {item.name}
                                    </a>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          </div>
                          <div className="d-flex gap-4">
                            {/* Product 5 */}
                            <div className="w-auto">
                              <span className="dropdown-header nav-text-dark">
                                {data[4].title}
                              </span>
                              <div className="dropdown-underlined"></div>
                              <ul className="list-group">
                                {data[4].products.map((item) => (
                                  <li
                                    key={item.id}
                                    className="nav-item list-group-item border-0 p-0 "
                                  >
                                    <a
                                      href={"/ProductDetail/" + item.id}
                                      className="dropdown-item pb-2 ps-3 border-radius-md text-red"
                                    >
                                      {item.name}
                                    </a>
                                  </li>
                                ))}
                              </ul>
                            </div>

                            {/* Product 6 */}
                            <div className="w-auto">
                              <span className="dropdown-header nav-text-dark">
                                {data[5].title}
                              </span>
                              <div className="dropdown-underlined"></div>
                              <ul className="list-group">
                                {data[5].products.map((item) => (
                                  <li
                                    key={item.id}
                                    className="nav-item list-group-item border-0 p-0 "
                                  >
                                    <a
                                      href={"/ProductDetail/" + item.id}
                                      className="dropdown-item pb-2 ps-3 border-radius-md text-red"
                                    >
                                      {item.name}
                                    </a>
                                  </li>
                                ))}
                              </ul>
                            </div>

                            {/* Product 7 */}
                            <div className="w-auto">
                              <span className="dropdown-header nav-text-dark">
                                {data[6].title}
                              </span>
                              <div className="dropdown-underlined"></div>
                              <ul className="list-group">
                                {data[6].products.map((item) => (
                                  <li
                                    key={item.id}
                                    className="nav-item list-group-item border-0 p-0 "
                                  >
                                    <a
                                      href={"/ProductDetail/" + item.id}
                                      className="dropdown-item pb-2 ps-3 border-radius-md text-red"
                                    >
                                      {item.name}
                                    </a>
                                  </li>
                                ))}
                              </ul>
                            </div>

                            {/* Product 8 */}
                            {/* <div className="w-auto d-block">
                            <div className="w-auto">
                              <span className="dropdown-header nav-text-dark">
                                {data[7].title}
                              </span>
                              <div className="dropdown-underlined"></div>
                              <ul className="list-group">
                                {data[7].products.map((item) => (
                                  <li
                                    key={item.id}
                                    className="nav-item list-group-item border-0 p-0 "
                                  >
                                    <a className="dropdown-item pb-2 ps-3 border-radius-md">
                                      {item.name}
                                    </a>
                                  </li>
                                ))}
                              </ul>
                            </div>

                            <div className="w-auto mt-3">
                              <span className="dropdown-header nav-text-dark">
                                {data[8].title}
                              </span>
                              <div className="dropdown-underlined"></div>
                              <ul className="list-group">
                                {data[8].products.map((item) => (
                                  <li
                                    key={item.id}
                                    className="nav-item list-group-item border-0 p-0 "
                                  >
                                    <a className="dropdown-item pb-2 ps-3 border-radius-md">
                                      {item.name}
                                    </a>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          </div> */}
                          </div>
                        </div>
                      </div>
                      {/* loop for navbar */}
                      <div className="d-none mob-nav-action">
                        <div className="text-dark mobile-nav">
                          {data.map((element) => (
                            <div className="mx-3 my-2 " key={element.title}>
                              <div className="d-flex justify-content-between align-items-center">
                                {element.title}
                                <div
                                  className="cursor-pointer d-flex align-items-center"
                                  onClick={() => {
                                    const dropdown = document.getElementById(
                                      element.title
                                    );
                                    if (
                                      dropdown.classList.contains("d-block")
                                    ) {
                                      dropdown.classList.remove("d-block");
                                      dropdown.classList.add("d-none");
                                    } else {
                                      dropdown.classList.remove("d-none");
                                      dropdown.classList.add("d-block");
                                    }
                                  }}
                                >
                                  <img
                                    src="../img/down-arrow-dark.svg"
                                    alt="down-arrow"
                                    className="arrow ms-1"
                                  />
                                </div>
                              </div>
                              {/* open a dropdown of specific product only when clicked on dropdown icon */}
                              <div className="d-none" id={element.title}>
                                {element.products.map((item) => (
                                  <div className="my-2 mx-4" key={item.id}>
                                    <a
                                      href={"/ProductDetail/" + item.id}
                                      className="text-dark"
                                    >
                                      {item.name}
                                    </a>
                                  </div>
                                ))}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </li>

                    <li className="nav-item mx-2">
                      <NavLink
                        to="/careers"
                        className={({ isActive }) =>
                          `nav-link ps-2 d-flex justify-content-between cursor-pointer align-items-center ${
                            isActive ? "text-primary font-weight-bold" : ""
                          }`
                        }
                      >
                        Careers
                      </NavLink>
                    </li>
                    <li className="nav-item mx-2">
                      <NavLink
                        to="/contact-us"
                        className={({ isActive }) =>
                          `nav-link ps-2 d-flex justify-content-between cursor-pointer align-items-center ${
                            isActive ? "text-primary font-weight-bold" : ""
                          }`
                        }
                      >
                        Contact Us
                      </NavLink>
                    </li>
                  </ul>
                  <ul className="navbar-nav d-lg-block d-none">
                    <li className="nav-item">
                      <img
                        src="../images/Logos/huge1.png"
                        style={{
                          width: "80px",
                          height: "auto",
                          objectFit: "contain",
                        }}
                      />
                    </li>
                  </ul>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;
